module.exports = __webpack_public_path__ + "img/7.97d1be5a.svg";